<img
  class="image"
  width="196"
  height="196"
  alt=""
  [src]="image()" />
<p class="message">{{ text() }}</p>
<ng-content />
